var f = 2e3, l = 4;
function u() {
  return new Promise((e) => {
    setTimeout(e, 0);
  });
}
async function T(e, a) {
  const s = a?.maxWaitMs ?? f, i = a?.quietTurns ?? l, o = Date.now() + s, r = e;
  if (typeof r.onLayoutSolved == "function") {
    let t = !1;
    const c = r.onLayoutSolved(() => {
      t = !0;
    });
    try {
      let n = 0;
      for (; n < i; ) {
        if (Date.now() >= o) return;
        await u(), t ? (t = !1, n = 0) : n++;
      }
    } finally {
      c();
    }
    return;
  }
  for (let t = 0; t < i; t++) {
    if (Date.now() >= o) return;
    await u();
  }
}
export {
  T as t
};

//# sourceMappingURL=settle-BdkUrROl.js.map